module.exports = __webpack_public_path__ + "static/img/null1.0bc9958e.png";